import { Heading, Text } from "@/src/components/ui/Typography";

import type { ImpactStatItemData } from "./ImpactGenerated.types";

interface ImpactStatItemProps {
  item: ImpactStatItemData;
}

export function ImpactStatItem({ item }: ImpactStatItemProps) {
  return (
    <div>
      <Heading as="h3" size="headingLG" className="text-neutral-700">
        {item.value}
      </Heading>

      <Text size="bodyMD" className="mt-2 text-neutral-700">
        {item.label}
      </Text>

      <Text size="bodySM" className="mt-2 text-neutral-700">
        {item.description}
      </Text>
    </div>
  );
}
